<sha-connectivity-banner></sha-connectivity-banner>
<div [class.bold-text]="localSettings.accessibility.boldText"
  [class.increase-contrast]="localSettings.accessibility.increaseContrast"
  [class.large-text]="localSettings.accessibility.largeText"
  [class.dark-theme]="localSettings.accessibility.theme === 'dark'"
  [class.light-theme]="localSettings.accessibility.theme === 'light'" class="body">
  <router-outlet></router-outlet>
</div>